// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Amount$LiveRoom from "../../Amount.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as RoundCurrencyFlag$LiveRoom from "../RoundCurrencyFlag.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../../stores/AlternativeCurrency.bs.js";

var currencyTypeAndName_0 = {
  currencyType: "AED",
  currencyName: "United Arab Emirates dirham"
};

var currencyTypeAndName_1 = {
  hd: {
    currencyType: "ARS",
    currencyName: "Argentine Peso"
  },
  tl: {
    hd: {
      currencyType: "AUD",
      currencyName: "Australian Dollar"
    },
    tl: {
      hd: {
        currencyType: "BRL",
        currencyName: "Brazilian Real"
      },
      tl: {
        hd: {
          currencyType: "CAD",
          currencyName: "Canadian Dollar"
        },
        tl: {
          hd: {
            currencyType: "CHF",
            currencyName: "Swiss Franc"
          },
          tl: {
            hd: {
              currencyType: "CNY",
              currencyName: "Chinese Yuan"
            },
            tl: {
              hd: {
                currencyType: "EUR",
                currencyName: "Euro"
              },
              tl: {
                hd: {
                  currencyType: "GBP",
                  currencyName: "British Pound"
                },
                tl: {
                  hd: {
                    currencyType: "HKD",
                    currencyName: "Hong Kong Dollars"
                  },
                  tl: {
                    hd: {
                      currencyType: "IDR",
                      currencyName: "Indonesian Rupiah"
                    },
                    tl: {
                      hd: {
                        currencyType: "INR",
                        currencyName: "Indian Rupee"
                      },
                      tl: {
                        hd: {
                          currencyType: "JPY",
                          currencyName: "Japanese Yen"
                        },
                        tl: {
                          hd: {
                            currencyType: "KRW",
                            currencyName: "South Korean Won"
                          },
                          tl: {
                            hd: {
                              currencyType: "MXN",
                              currencyName: "Mexican Peso"
                            },
                            tl: {
                              hd: {
                                currencyType: "PHP",
                                currencyName: "Philippine Peso"
                              },
                              tl: {
                                hd: {
                                  currencyType: "QAR",
                                  currencyName: "Qatari Riyal"
                                },
                                tl: {
                                  hd: {
                                    currencyType: "RUB",
                                    currencyName: "Russian Ruble"
                                  },
                                  tl: {
                                    hd: {
                                      currencyType: "SAR",
                                      currencyName: "Saudi Riyal"
                                    },
                                    tl: {
                                      hd: {
                                        currencyType: "SGD",
                                        currencyName: "Singapore Dollar"
                                      },
                                      tl: {
                                        hd: {
                                          currencyType: "TWD",
                                          currencyName: "New Taiwan Dollar"
                                        },
                                        tl: {
                                          hd: {
                                            currencyType: "USD",
                                            currencyName: "United States Dollar"
                                          },
                                          tl: {
                                            hd: {
                                              currencyType: "ETH",
                                              currencyName: "Ethereum"
                                            },
                                            tl: {
                                              hd: {
                                                currencyType: "BTC",
                                                currencyName: "Bitcoin"
                                              },
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

var currencyTypeAndName = {
  hd: currencyTypeAndName_0,
  tl: currencyTypeAndName_1
};

function AlternativeCurrencyModal$CurrencyInfo(props) {
  var selectedCurrencyType = props.selectedCurrencyType;
  return React.createElement(React.Fragment, undefined, React.createElement("span", {
                  className: Curry._1(Css.style, {
                        hd: Css.marginLeft(Css.px(16)),
                        tl: {
                          hd: Css.marginRight(Css.px(16)),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                  hd: Css.marginLeft(Css.px(8)),
                                  tl: {
                                    hd: Css.marginRight(Css.px(8)),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: /* [] */0
                          }
                        }
                      })
                }, React.createElement(RoundCurrencyFlag$LiveRoom.make, {
                      flagCode: selectedCurrencyType
                    })), React.createElement("span", {
                  "aria-hidden": true
                }, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                      children: Amount$LiveRoom.currencyToString(selectedCurrencyType)
                    })), React.createElement("span", {
                  className: Curry._1(Css.style, {
                        hd: Css.width(Css.pct(100)),
                        tl: {
                          hd: Css.textAlign("right"),
                          tl: {
                            hd: Css.marginRight(Css.px(16)),
                            tl: /* [] */0
                          }
                        }
                      })
                }, React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                      children: props.selectedCurrencyName
                    })));
}

var CurrencyInfo = {
  make: AlternativeCurrencyModal$CurrencyInfo
};

function AlternativeCurrencyModal(props) {
  var setAlternativeCurrency = props.setAlternativeCurrency;
  var onClose = props.onClose;
  var sapSaleNumber = props.sapSaleNumber;
  var baseCurrency = props.baseCurrency;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var onCurrencySelect = AlternativeCurrency$LiveRoom.useOnCurrencySelect(baseCurrency, setAlternativeCurrency);
  var selectedCurrency = alternativeCurrency !== undefined ? alternativeCurrency.currency : baseCurrency;
  var currencyList = Belt_List.keep(currencyTypeAndName, (function (c) {
          if (Caml_obj.notequal(c.currencyType, baseCurrency)) {
            return Caml_obj.notequal(c.currencyType, selectedCurrency);
          } else {
            return false;
          }
        }));
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.pct(100)),
                    tl: {
                      hd: Css.height(Css.pct(100)),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                              hd: Css.important(Css.maxHeight(Css.pct(100))),
                              tl: {
                                hd: Css.important(Css.maxWidth(Css.pct(100))),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              onClose: onClose,
              isOpen: true,
              size: "large",
              headerTitle: Curry._1(t, "CurrencyConverter")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: null,
                  className: Curry._1(Css.style, {
                        hd: Css.overflowY("auto"),
                        tl: /* [] */0
                      })
                }, React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                      children: Curry._1(t, "DisplayCurrencyEstimateAndBidValues")
                    }), Belt_Option.isSome(alternativeCurrency) ? React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.marginTop(Css.px(24)),
                              tl: /* [] */0
                            })
                      }, React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                            className: Curry._1(Css.style, {
                                  hd: Css.important(Css.fontWeight({
                                            NAME: "num",
                                            VAL: 600
                                          })),
                                  tl: {
                                    hd: Css.marginTop(Css.px(24)),
                                    tl: {
                                      hd: Css.marginBottom(Css.px(8)),
                                      tl: /* [] */0
                                    }
                                  }
                                }),
                            children: Curry._1(t, "SelectedCurrency")
                          }), React.createElement("div", {
                            className: Curry._1(Css.style, {
                                  hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey10_nohashtag)),
                                  tl: {
                                    hd: Css.width(Css.pct(100)),
                                    tl: {
                                      hd: Css.display("flex"),
                                      tl: {
                                        hd: Css.alignItems("center"),
                                        tl: {
                                          hd: Css.height(Css.px(48)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                })
                          }, React.createElement(AlternativeCurrencyModal$CurrencyInfo, {
                                selectedCurrencyType: selectedCurrency,
                                selectedCurrencyName: Belt_Option.mapWithDefault(Belt_List.getBy(currencyTypeAndName, (function (x) {
                                            return Caml_obj.equal(x.currencyType, selectedCurrency);
                                          })), "", (function (x) {
                                        return x.currencyName;
                                      }))
                              })), React.createElement("div", {
                            className: Curry._1(Css.style, {
                                  hd: Css.marginTop(Css.px(24)),
                                  tl: {
                                    hd: Css.borderBottom(Css.px(1), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag)),
                                    tl: /* [] */0
                                  }
                                })
                          })) : null, React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.width(Css.pct(100.0)),
                            tl: {
                              hd: Css.paddingTop(Css.px(40)),
                              tl: {
                                hd: Css.selector(" button:nth-child(odd)", {
                                      hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey10_nohashtag)),
                                      tl: /* [] */0
                                    }),
                                tl: /* [] */0
                              }
                            }
                          })
                    }, Belt_List.toArray(Belt_List.map(currencyList, (function (c) {
                                return JsxPPXReactSupport.createElementWithKey(Amount$LiveRoom.currencyToString(c.currencyType), Button.Button, {
                                            onClick: (function (param) {
                                                AnalyticsManager$LiveRoom.currencySelected(Amount$LiveRoom.currencyToString(baseCurrency), Amount$LiveRoom.currencyToString(c.currencyType), sapSaleNumber, "AuctionRoom");
                                                Curry._1(onCurrencySelect, c.currencyType);
                                                Curry._1(onClose, undefined);
                                              }),
                                            className: Curry._1(Css.style, {
                                                  hd: Css.display("flex"),
                                                  tl: {
                                                    hd: Css.height(Css.px(48)),
                                                    tl: {
                                                      hd: Css.alignItems("center"),
                                                      tl: {
                                                        hd: Css.hover({
                                                              hd: Css.cursor("pointer"),
                                                              tl: {
                                                                hd: Css.important(Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag))),
                                                                tl: {
                                                                  hd: Css.transition({
                                                                        NAME: "ms",
                                                                        VAL: 150
                                                                      }, undefined, undefined, "background-color"),
                                                                  tl: /* [] */0
                                                                }
                                                              }
                                                            }),
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }),
                                            buttonStyle: "tertiary",
                                            children: React.createElement(AlternativeCurrencyModal$CurrencyInfo, {
                                                  selectedCurrencyType: c.currencyType,
                                                  selectedCurrencyName: c.currencyName
                                                })
                                          });
                              }))))), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: null
                }, Belt_Option.isSome(alternativeCurrency) ? React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(setAlternativeCurrency, undefined);
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.important(Css.width("auto")),
                              tl: {
                                hd: Css.marginRight(Css.px(16)),
                                tl: /* [] */0
                              }
                            }),
                        buttonStyle: "secondary",
                        children: Curry._1(t, "ClearSelectedCurrency")
                      }) : null, React.createElement(Button.Button, {
                      onClick: (function (param) {
                          Curry._1(onClose, undefined);
                        }),
                      className: Curry._1(Css.style, {
                            hd: Css.important(Css.width(Css.px(103))),
                            tl: /* [] */0
                          }),
                      children: Curry._1(t, "Common_close")
                    })));
}

var make = AlternativeCurrencyModal;

export {
  currencyTypeAndName ,
  CurrencyInfo ,
  make ,
}
/* Css Not a pure module */
